/**
 * Date formatting shared by the mobile cards.
 */

/**
 * Renders a date the way these lists have always shown it: the value as a string with its trailing
 * time portion removed.
 *
 * The cards each did this inline with a substring of length - 9, repeated in four files. Kept to the
 * same behaviour rather than switched to a locale format, so the dates on screen do not change.
 * @param value {string|Date|null|undefined}
 * @returns {string|null} null when there is no date, which MobileCard renders as a dash
 */
export function trimDate(value) {
    if (!value) {
        return null;
    }

    const text = value.toString();

    return text.length > 9 ? text.substring(0, text.length - 9) : text;
}
